import { createCustomSelector } from '../utils/react-reselect'
import { selectIsASearchPage, selectIsASearchOnItineraryPage } from '../../store/history/history.selectors'
import { TAG_CLICK_POI, TAG_CLICK_POI_FICHE_ADDRESSE } from '../analytics/analytics.tagids.constants'
import { useSelector } from 'react-redux'
import { useGeoentityIndex } from './useGeoentityIndex'
import {
  getPoiApplicationId,
  getPoiAverageNote,
  getPoiMaxNote,
  getPoiNumberOfReviews,
  getPoiRubricId
} from '../../store/geoentity/geoentity.accessors'
import { APP_ID, CAT_ID, RUBRIC } from '../analytics/ClickTagsService'
import { useSelectorWithProps } from '../utils/react-redux'
import { selectSubcategoryByRubricId } from '../../store/poiassets/poiassets.selectors'
import { selectGeoentitiesFilters, selectGeoentityFilterParameters } from '../../store/geoentity/filter.selectors'
import { POIS_FILTERS } from '../search/filters/filters.constants'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'

const selectTagType = createCustomSelector(
  selectIsASearchPage,
  selectIsASearchOnItineraryPage,
  (searchPage, searchOnItiPage) => (searchPage || searchOnItiPage ? TAG_CLICK_POI : TAG_CLICK_POI_FICHE_ADDRESSE)
)

const selectAvailableFilters = createCustomSelector(selectGeoentitiesFilters, filters =>
  filters
    .map(filter => {
      switch (filter.type) {
        case POIS_FILTERS.multidatepicker.type:
          return `${filter.fromDateParameter},${filter.toDateParameter}`
        case POIS_FILTERS.slider.type:
          return `${filter.minParameter},${filter.maxParameter}`
        default:
          return filter.parameter
      }
    })
    .join(',')
)

const selectCheckedFilters = createCustomSelector(selectGeoentityFilterParameters, filterParameters =>
  Object.values(filterParameters ?? {})
    .map((parameters = {}) => Object.keys(parameters).join(','))
    .join(',')
)

export const useGoToGeoentityTagData = (poi, tagInfo = {}) => {
  const tagType = useSelector(selectTagType)
  const index = useGeoentityIndex(poi)
  const subcategory = useSelectorWithProps(selectSubcategoryByRubricId, { id: getPoiRubricId(poi) })
  const availableFilters = useSelector(selectAvailableFilters)
  const checkedFilters = useSelector(selectCheckedFilters)

  return {
    type: tagType,
    tagInfo: {
      [APP_ID]: getPoiApplicationId(poi),
      [CAT_ID]: subcategory?.id,
      [RUBRIC]: getPoiRubricId(poi),
      affichage: tagInfo?.zone ?? 'liste',
      postcode: poi.postcode,
      note: getPoiAverageNote(poi) && `${getPoiAverageNote(poi)}/${getPoiMaxNote(poi)}`,
      nbAvis: getPoiNumberOfReviews(poi),
      zone: 'liste',
      indexInList: index + 1,
      [CLICKED_BUTTON]: 'bloc',
      idPoi: poi.id,
      availableFilters,
      checkedFilters,
      ...tagInfo
    }
  }
}
